module.exports = __webpack_public_path__ + "static/img/23f.91970eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/23f.jpg
// module id = tEPt
// module chunks = 0